import React, { FC, ReactNode } from "react";
import clsx from "clsx";

import styles from "./index.module.css";

type BoxProps = {
  children: ReactNode;
  className?: string;
};

const Box: FC<BoxProps> = (props) => {
  const { children, className } = props;
  return <div className={clsx(styles.container, className)}>{children}</div>;
};

export default Box;
